// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__9gyq5","error":"Captcha_error__x2FX2"};